import { Component, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { AuthService } from "../../../services/api/auth/auth.service";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { SnackbarService } from "../../../services/snackbar/snackbar.service";
import { ThemeService } from "../../../services/theme/theme.service";

@Component({
  selector: "app-forgot-password",
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: "./forgot-password.component.html",
  styleUrl: "./forgot-password.component.scss",
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  errorMessage: string = "";
  snackService = inject(SnackbarService);
  themeService = inject(ThemeService);

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
  ) {
    this.forgotPasswordForm = this.fb.group({
      forgotPasswordEmail: ["", [Validators.required, Validators.email]],
    });
  }

  getEmailErrorMessage() {
    const emailControl = this.forgotPasswordForm.get("forgotPasswordEmail");
    if (!emailControl) return null;
    if (emailControl.valid || (!emailControl.dirty && !emailControl.touched)) {
      return null;
    }
    if (emailControl?.hasError("required")) {
      return "You must enter an email";
    }
    if (emailControl?.hasError("email")) {
      return "Not a valid email";
    }
    return null;
  }

  forgotPassword(): void {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }
    const { forgotPasswordEmail } = this.forgotPasswordForm.value;
    this.authService.forgotPassword(forgotPasswordEmail).subscribe({
      next: (response) => {
        if (response && response.state === "reset_link_sent") {
          this.errorMessage = "";
          this.snackService.show({
            message: "Password reset link sent to your email",
            duration: 5000,
          });
          this.router.navigate(["login"]);
        }
      },
      error: (err) => {
        this.errorMessage =
          err.message || "An error occurred. Please try again.";
        console.error("Forgot Password Error: ", err);
      },
    });
  }

  // Navigate to the Login Page
  backToLogin(): void {
    this.router.navigate(["login"]);
  }
}
